'use client';
import { useEffect } from 'react';
export const useSidecarFocusInput = ({ entropyBrowser, isSidecar, focusInput, }) => {
    useEffect(() => {
        if (!entropyBrowser || !isSidecar) {
            return;
        }
        const handleVisibilityChange = () => {
            const isCurrentlyVisible = document.visibilityState === 'visible';
            if (isCurrentlyVisible) {
                focusInput();
            }
        };
        const quickActionButtonUnsubFn = entropyBrowser.subscribeQuickActionButtonFired(() => {
            focusInput();
        });
        const sourceTabChangedUnsubFn = entropyBrowser.subscribeSourceTabChanged(() => {
            focusInput();
        });
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            quickActionButtonUnsubFn();
            sourceTabChangedUnsubFn();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [entropyBrowser, focusInput, isSidecar]);
};
//# sourceMappingURL=useSidecarFocusInput.js.map